import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { environment } from "../../environments/environment";
import { map } from "rxjs/operators";
import { Info } from "../models/user.interface";
import { BehaviorSubject, Observable } from "rxjs";
import { ApiPagedResponse, ApiResponse } from "../models/utils/ApiResponse";
import { Disbursement } from "../models/desembolso/Disbursement";

const apiUrl = environment.apiURL;
const creditApiUrl = environment.apiCredit;

@Injectable({
  providedIn: "root",
})
export class CajaService {
  manejarHorror: any;

  recibo: any;
  private currentReciboSubject: BehaviorSubject<any>;
  public currentRecibo: Observable<Info>;

  constructor(private http: HttpClient) {
    this.currentReciboSubject = new BehaviorSubject<any>(
      JSON.parse(localStorage.getItem("recibo"))
    );
  }

  public get currentReciboValue(): Info {
    return this.currentReciboSubject.value;
  }

  cargarCargos() {
    return this.http.get<any>(`${apiUrl}api/cob/metas/metas`).pipe(
      map((res: any) => {
        return res;
      })
    );
  }

  cargarTipoCuenta() {
    return this.http.get<any>(`${apiUrl}api/par/tipocuenta/lista`).pipe(
      map((res: any) => {
        return res;
      })
    );
  }

  cargarBancos() {
    return this.http.get<any>(`${apiUrl}api/par/bancos/lista`).pipe(
      map((res: any) => {
        return res;
      })
    );
  }

  cargarRecibos() {
    return this.http.get<any>(`${apiUrl}api/cob/cobro/lista`).pipe(
      map((res: any) => {
        return res;
      })
    );
  }

  cargarRecibosSmcf() {
    return this.http.get<any>(`${apiUrl}api/cob/cobro/listasmcf`).pipe(
      map((res: any) => {
        return res;
      })
    );
  }

  cargarCargosDetalle(tipo: any) {
    const httpOptions = {
      params: { tipo: tipo },
    };
    return this.http
      .get<any>(`${apiUrl}api/cob/metas/detalle`, httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }

  cargarRecuperaciones(fechaInicio: any, fechaFin: any) {
    const httpOptions = {
      params: { fechaInicio: fechaInicio, fechaFin: fechaFin },
    };
    return this.http
      .get<any>(`${apiUrl}api/cob/recuperaciones/lista`, httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }

  cargarAnalisisCartera(FechaInicio: any, FechaFin: any, CodigoCredito: any) {
    const httpOptions = {
      params: { FechaInicio, FechaFin, CodigoCredito },
    };
    return this.http
      .get<any>(`${apiUrl}api/cre/creditolinea/analisiscartera`, httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }

  cargarDesembolsos(
    fechaInicio: Date,
    fechaFin: Date,
    filtros: { [key: string]: any },
    pagina = 1,
    tamaño = 10
  ) {
    let params = new HttpParams()
      .set("startDate", fechaInicio.toISOString())
      .set("endDate", fechaFin.toISOString())
      .set("page", pagina.toString())
      .set("pageSize", tamaño.toString());

    // Construir parámetros para que se enlacen a Dictionary<string, string>? filters
    // Ejemplos en query:
    //   filters[status]=Anulado
    //   filters[active]=1
    let hasAnyFilter = false;

    if (filtros) {
      const status = filtros["accountStatementStatus"];
      if (status !== undefined && status !== null && status !== "") {
        hasAnyFilter = true;
        params = params.set("filters[status]", String(status));
      }

      const active = filtros["active"];
      if (active !== undefined && active !== null && active !== "") {
        hasAnyFilter = true;
        const activeValue = active ? "1" : "0";
        params = params.set("filters[active]", activeValue);
      }
    }

    // Si no hay filtros activos, el API espera igualmente el parámetro filters en null
    if (!hasAnyFilter) {
      params = params.set("filters", "null");
    }

    return this.http.get<ApiPagedResponse<Disbursement>>(
      `${creditApiUrl}api/disbursement`,
      { params }
    );
  }

  confirmarColocacion(payload: any) {
    return this.http.patch<any>(
      `${creditApiUrl}api/confirm-disbursement/${payload.statementId}`,
      payload
    );
  }

  listarComentarios(estadoCuenta: number) {
    return this.http.get<any>(
      `${creditApiUrl}api/confirm-disbursement/disbursement/${estadoCuenta}/comments`
    );
  }

  listarComparativoMora(data: any) {
    return this.http
      .post<any>(`${apiUrl}api/cob/controlmora/comparativo`, data)
      .pipe(
        map((res) => {
          return res;
        })
      );
  }

  // tslint:disable-next-line:max-line-length
  listarComparativoMoraDetalle(
    idRango: any,
    fecha: any,
    tipoRango: any,
    idOficina: any = 0,
    IdMonedaConversion = 0,
    OrigenDeDatos = 0,
    CodigoCartera = 0
  ) {
    const httpOptions = {
      // tslint:disable-next-line:max-line-length
      params: {
        IdRango: idRango,
        Fecha: fecha,
        TipoRango: tipoRango,
        IdOficina: idOficina,
        IdMonedaConversion: IdMonedaConversion,
        OrigenDeDatos: OrigenDeDatos,
        CodigoCartera: CodigoCartera,
      },
    };
    return this.http
      .get<any>(`${apiUrl}api/cob/controlmora/detalle`, httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }

  cargarColocaciones(fechaInicio: any, fechaFin: any) {
    const httpOptions = {
      params: { fechaInicio: fechaInicio, fechaFin: fechaFin },
    };
    return this.http
      .get<any>(`${apiUrl}api/cli/reportes/colocaciones`, httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }

  cargarCartera(fecha: any) {
    const httpOptions = {
      params: { Fecha: fecha },
    };
    return this.http
      .get<any>(`${apiUrl}api/cre/creditolinea/rpt/cartera`, httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }

  cargarCarteraMovimiento(FechaInicio: any, FechaFin: any) {
    const httpOptions = {
      params: { FechaInicio, FechaFin },
    };
    return this.http
      .get<any>(
        `${apiUrl}api/cre/estadocuenta/rptcartera/movimientos`,
        httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }

  cargarProyecciones() {
    return this.http
      .get<any>(`${apiUrl}api/cob/recuperaciones/proyecciones`)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }

  monedaCredito(codigoCredito: any) {
    const httpOptions = {
      params: { CodigoCredito: codigoCredito },
    };
    return this.http
      .get<any>(`${apiUrl}/api/cob/cobro/get/monedacredito`, httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }

  realizarPago(datos: any) {
    return this.http
      .post<any>(`${apiUrl}api/cob/cobro/aplicarV2`, JSON.stringify(datos))
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }

  realizarPagoAfiliado(datos: any) {
    return this.http
      .post<any>(
        `${apiUrl}api/cli/afiliado/pagos/aplicar`,
        JSON.stringify(datos)
      )
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }

  recibirRecibo(datos: any) {
    this.recibo = datos;
    localStorage.removeItem("recibo");
    localStorage.setItem("recibo", JSON.stringify(this.recibo));
    this.currentReciboSubject = new BehaviorSubject<any>(
      JSON.parse(localStorage.getItem("recibo"))
    );
  }

  enviarRecibo() {
    return this.recibo;
  }

  cargarDetalleCredito(codigoCredito: any) {
    const httpOptions = {
      params: { codigoCredito: codigoCredito },
    };
    return this.http
      .get<any>(`${apiUrl}/api/cob/cobro/detalle`, httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }

  cargarCargoEfectivo(codigoCredito: any) {
    const httpOptions = {
      params: { codigoCredito: codigoCredito },
    };
    return this.http
      .get<any>(`${apiUrl}api/cob/cobro/cargoactivacion/detalle`, httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }

  cargarCuentasBanco(idMoneda: any) {
    const httpOptions = {
      params: { idMoneda: idMoneda },
    };
    return this.http
      .get<any>(`${apiUrl}api/par/bancos/cuentas`, httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }

  cargarDetalleCreditoV2(codigoCredito: any) {
    const httpOptions = {
      params: { CodigoCredito: codigoCredito },
    };
    return this.http
      .get<any>(`${apiUrl}/api/cob/cobro/detalle/v2`, httpOptions)
      .pipe(
        map((res: any) => {
          console.log("Prueba1", res);
          return res;
        })
      );
  }

  // #################################################################################################

  /**
   *
   * Servicios Deposito
   *
   */
  estadoCobrador(fecha: any, idUsuario: any) {
    const httpOptions = {
      params: {
        Fecha: fecha,
        IdUsuario: idUsuario,
      },
    };
    return this.http
      .get<any>(`${apiUrl}/api/cob/operacionDelDia/estadocobrador`, httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }
  cargarDepositos(fecha: any, idUsuarioFiltro: any) {
    const httpOptions = {
      params: {
        Fecha: fecha,
        IdUsuarioFiltro: idUsuarioFiltro,
      },
    };
    return this.http
      .get<any>(`${apiUrl}/api/cob/deposito/lista`, httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }
  notificarDeposito() {
    return this.http
      .post<any>(`${apiUrl}api/cob/deposito/notificar`, null)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }
  confirmarDeposito(datos: any) {
    return this.http
      .post<any>(`${apiUrl}api/cob/deposito/confirmar`, JSON.stringify(datos))
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }
  guardarActualizarDeposito(datos: any) {
    return this.http
      .post<any>(
        `${apiUrl}api/cob/deposito/guardar-actualizar`,
        JSON.stringify(datos)
      )
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }
  cerrar(info: any) {
    return this.http
      .post<any>(
        `${apiUrl}api/cob/operacionDelDia/cerrar?idUsuario=${info.idUsuario}&observacion=${info.observacion}`,
        null
      )
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }
  // cerrar() {
  //   return this.http
  //     .post<any>(`${apiUrl}api/cob/operacionDelDia/cerrar`, null)
  //     .pipe(
  //       map((res: any) => {
  //         return res;
  //       })
  //     );
  // }
  // #################################################################################################


}
